import httpClient from "./httpClient";

/**
 * Binds the four generic lookup endpoints (list/create/update/delete) to one
 * `/api/settings/<resourcePath>` resource — the frontend mirror of the
 * backend's `AbstractLookupController<T>` (see MIGRATION.md). Every simple
 * "core setting" page (academic years, classes, shifts, ...) is built on
 * this instead of one API module per resource.
 */
export function createLookupApi(resourcePath) {
  const base = `/settings/${resourcePath}`;

  return {
    list: () => httpClient.get(base).then((res) => res.data.data),
    create: (payload) => httpClient.post(base, payload).then((res) => res.data.data),
    update: (id, payload) => httpClient.put(`${base}/${id}`, payload).then((res) => res.data.data),
    remove: (id) => httpClient.delete(`${base}/${id}`).then((res) => res.data),
  };
}
